// @flow
/**
 * Created by ivo on 08.01.17.
 *
 * DAT files parser
 */

import t from './trans';
import GlassFileParser from './GlassFileParser';

class DatFileParser extends GlassFileParser {

    /**
     * Parses glass data file
     */
    parseData() {
        // Vt rida 3993 failis dat2gr2.frm

        // Failis on andmed esitatud ridades, iga rida on jagatud veergudeks, veerueraldajaks on TAB sümbol
        // Esimene rida on tahvelx, tahvely - seda ignoreerime (see arvutatakse globaalselt uuesti)
        let l = this.getFloatLine(2);
        // this.tahvelx = l[0];
        // this.tahvely = l[1];

        // Teine rida sisldab joonte arvu
        l = this.getIntLine(1);
        let jooni = l[0];

        // Edasi tuleb joonte arv ridu, mis määravad ridade arvud
        this.ridu = 0;
        let i = 0;
        for (i = 0; i < jooni; i++) {
            l = this.getIntLine(3);
            this.ridu += l[1] - l[0] + 1;
        }

        // Edasi ignoreerime järelejäänud 30-(joonte arv) ridu:
        for (; i < 30; i++) {
            this.readLine();
        }

        // Ridade arv punkte:
        for (i = 0; i < this.ridu; i++) {
            l = this.getFloatLine(6);
            if (l[2] != 0) throw t("Invalid data, arcs are not supported on line %s", this.lineno);
            this.joony1[i] = l[0];
            this.joony2[i] = l[1];
            this.joonx1[i] = l[3];
            this.joonx2[i] = l[4];
        }
    }

    /**
     * Loeb rea, parsib sellest veerud, teisendab numbriteks (võivad olla nii täisarvud kui reaalarvud) ning tagastab need massiivina.
     * Massiivis saab esineda ka null väärtusi - need vastavad tühjadele veergudele
     * Vigased numbrid toovad kaasa throw
     * @returns {Array}
     */
    getLine(len) {
        let l = this.readLine();
        let result = [];
        if (l != null && l != "") {
            let splittedLine = l.split("\t");
            for (let val of splittedLine) {
                if (val == "") result.push(null);
                else result.push(val);
            }
        }

        if (len && result.length != len) throw t("Invalid data on line %s", this.lineno);
        return result;
    }

    getFloatLine(len) {
        let l = this.getLine(len);
        let values = [];
        for (let v of l) {
            values.push(this.getFloat(v));
        }
        return values;
    }

    getIntLine(len) {
        let l = this.getLine(len);
        let values = [];
        for (let v of l) {
            values.push(this.getInt(v));
        }
        return values;
    }

    getInt(val) {
        let numVal = Number.parseInt(val);
        if (Number.isNaN(numVal)) throw t("Invalid data on line %s", this.lineno);
        return numVal;
    }

    getFloat(val) {
        let numVal = Number.parseFloat(val);
        if (Number.isNaN(numVal)) throw t("Invalid data on line %s", this.lineno);
        return numVal;
    }
}

export default DatFileParser;
